const mobileMenuBreakpoint = 1200;
const $win = $(window);
const $body = $("body");
const $html = $("html");

const $header = $("header");
const $headerMenu = $header.find("#menu-main-menu");
const $headerNav = $header.find(".wp-classic-menu-block");
let $previousItem = $();
const $menuItems = $("#menu-main-menu").children(".menu-item-has-children");

function NavigateMobileSubMenu(level, $subMenu) {
  $subMenu = $subMenu || null;
  if ($subMenu) {
    $headerMenu
      .find(".sub-menu[data-level=" + level + "]")
      .removeClass("active");
    $subMenu.addClass("active");
  }
  $headerMenu.css("transform", "translate(" + -100 * level + "%)");
  $headerNav.attr("data-currentlevel", level);
}

$header.find(".sub-menu-back").click(function () {
  const level = $(this).attr("data-backlevel");
  NavigateMobileSubMenu(level);
});

$menuItems.on("click", function (event) {
  if ($(window).outerWidth() > 1200) {
    console.log($(event.target))
    if ( $(event.target).is($menuItems) || $(event.target).is("#menu-main-menu > li > a") || $(event.target).is("#menu-main-menu > li > a > span") ) {
      console.log("clicked on menu item");
      event.preventDefault();
      if (
        $(this).hasClass("menu-item-transition") !==
        $previousItem.hasClass("menu-item-transition")
      ) {
        $previousItem.removeClass("menu-item-transition");
      }
      $previousItem = $(this);
      $(this).toggleClass("menu-item-transition");
      console.log("this is working");
    }
  } else {
    const $subMenu = $(this).find("> .sub-menu");
  }
});

$header.find(".menu-item-has-children").each(function () {
  const $self = $(this);
  const $link = $self.children("a").first(); // only direct <a>
  const $subMenu = $self.children(".sub-menu").first();
  const $subMenuBack = $subMenu.find("> .sub-menu__back");

  const linkHref = $link.attr("href");
  if (linkHref !== "#" && linkHref !== "" && linkHref !== undefined) {
    const $menuItemDuplicate = $('<li class="menu-item menu-item--duplicate"></li>');
    $link.clone().appendTo($menuItemDuplicate);
    $subMenuBack.after($menuItemDuplicate);
  }

  $link.on("click", function (event) {
    if ($win.outerWidth() <= mobileMenuBreakpoint) {
      event.preventDefault();

      // Update the back button text with the parent link text
      const parentText = $link.text().trim();
      const $backButton = $subMenu.find("> .sub-menu__back .sub-menu-back");
      if ($backButton.length && parentText) {
        $backButton.text(parentText);
      }

      // Show submenu using your existing function
      NavigateMobileSubMenu($subMenu.data("level"), $subMenu);
    }
  });
});

$(document).on("click", function (event) {
  if (!$(event.target).closest("header").length) {
    if ($previousItem.hasClass("menu-item-transition")) {
      $previousItem.removeClass("menu-item-transition");
    }
  }
});

function adjustSubMenuPosition($parentItem) {
  if (!$parentItem || !$parentItem.length) return;

  const $subMenu = $parentItem.children(".sub-menu");
  if (!$subMenu.length || !$subMenu.is(":visible")) return;

  const parentOffset = $parentItem.offset().left;
  const subMenuRight = parentOffset + $subMenu.outerWidth();
  const windowWidth = $(window).width(); // assuming $win is not defined globally

  if (subMenuRight > windowWidth) {
    const overflowAmount = subMenuRight - windowWidth;
    $subMenu.css({
      left: `-${overflowAmount + 20}px`,
    });
  } else {
    $subMenu.css("left", ""); // reset if no overflow
  }
}

// Only run this on larger screens
function bindSubMenuHoverHandlers() {
  if ($win.outerWidth() > mobileMenuBreakpoint) {
    $(".menu-item").each(function () {
      const $menuItem = $(this);
      const $subMenu = $menuItem.children(".sub-menu");

      $menuItem.on("mouseenter", function () {
        adjustSubMenuPosition($menuItem);
      });

      $menuItem.on("mouseleave", function () {
        $subMenu.css("left", ""); // Reset on mouse leave
      });
    });
  }
}

// Reset submenu positions on resize
$(window).on("resize", function () {
  $(".sub-menu").css("left", ""); // Reset all
  bindSubMenuHoverHandlers();     // Rebind after breakpoint change
});

// Initial binding
bindSubMenuHoverHandlers();

$(".mobile-close, .mobile-menu-toggle, .close-menu").click(function () {
  $html.toggleClass("open");
  if ($html.hasClass("open")) {
    $win.scrollTop(0);
  }
  $headerNav.toggleClass("open");
  $("#mobile-menu-toggle").toggleClass("is-active");
  $header.toggleClass("open");
});

// Add header height as css var.
function setMenuHeightVar() {
  $body.css("--header-height", $header.height() + "px");
}

// Do this on resize
$(window).on("resize load", function () {
  setMenuHeightVar();
  adjustSubMenuPosition();
});

$(".site-header .sub-menu-back").click(function () {
  const $parentLi = $(this).closest("li.nav-column");
  const level = $(this).attr("data-backlevel");
  if ($parentLi.length) {
    const newLevel = parseInt(level) - 1;
    NavigateMobileSubMenu(newLevel);
  } else {
    NavigateMobileSubMenu(level);
  }
});
